/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { PurchaseIteration } from './PurchaseIteration';
import { TransactionState } from './TransactionState';
const BasePurchaseParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['state', TransactionState],
    ['successAt', /* #__PURE__ */ parsers.maybeNull(parsers.moment), 'success_at'],
    ['updatedAt', parsers.moment, 'updated_at'],
    ['shortId', codecString, 'short_id'],
    ['itemPurchaseIteration', PurchaseIteration, 'item_purchase_iteration'],
]));
export class BasePurchase extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BasePurchaseParser.decode(input).map(res => new BasePurchase(res));
    }
    static unsafeDecode(input) {
        return BasePurchase.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BasePurchaseParser.encode(data);
    }
    static schema() {
        return BasePurchaseParser.schema();
    }
}
